import { useReactiveVar } from '@apollo/client';
import { Box } from '@mui/material';
import { reactiveVariables } from 'modules/common/layer00';
import {
  ProjectInstallationSummaryTable,
  ProjectInstallationTable
} from 'modules/components/layer25';
import React, { useEffect } from 'react';

import { useParams } from 'react-router-dom';



export type InstallationsListSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationsListSectionProps) => {
  const params = useParams();
  const milestoneId = params.milestoneId ?? '';
  const installationFilter = useReactiveVar(reactiveVariables.filterInstallationsVar);

  useEffect(() => {
    if (installationFilter.milestoneId !== milestoneId) {
      reactiveVariables.resetInstallationFilter({
        milestoneId
      });
    }
    return () => {};
  }, [
    installationFilter.milestoneId,
    milestoneId
  ]);

  return (
    <Box >{
      installationFilter.isGrouped
        ? (
          <ProjectInstallationSummaryTable.FC />
        )
        : (
          <ProjectInstallationTable.FC />

        )
    }
    </Box>
  );
};
